class BigMenu extends HTMLElement {
  constructor() {
    super();
    this.panel = this.querySelector('.big-menu__panel');
    this.isHovered = false;
    this.bindEvents();
    this.initializeActiveState();
  }

  initializeActiveState() {
    // Keep panel open if it has an active child (only if not hovering another menu)
    if (this.dataset.hasActiveChild === "true" && !BigMenu.currentHoveredMenu) {
      if (this.panel) {
        this.panel.style.display = "block";
      }
    }
  }

  static currentHoveredMenu = null;

  static closeAllPanels(exceptElement = null) {
    // Close all big-menu panels except the one specified
    // When hovering a menu, close ALL other panels (even active ones)
    const allBigMenus = document.querySelectorAll('big-menu');
    allBigMenus.forEach(bigMenu => {
      if (bigMenu === exceptElement) {
        return;
      }
      
      const panel = bigMenu.querySelector('.big-menu__panel');
      if (panel) {
        // Always close when hovering a different menu
        panel.style.display = "none";
      }
    });
  }

  static restoreActivePanels() {
    // Restore panels that have active children when not hovering any menu
    const allBigMenus = document.querySelectorAll('big-menu');
    allBigMenus.forEach(bigMenu => {
      if (bigMenu.dataset.hasActiveChild === "true" && bigMenu !== BigMenu.currentHoveredMenu) {
        const panel = bigMenu.querySelector('.big-menu__panel');
        if (panel) {
          panel.style.display = "block";
        }
      }
    });
  }

  bindEvents() {
    // Handle mouseenter on the big-menu element
    this.addEventListener("mouseenter", (event) => {
      // IMPORTANT: Close all other panels FIRST, before setting currentHoveredMenu
      // This ensures panels with active children are closed immediately
      BigMenu.closeAllPanels(this);
      
      // Set this as the currently hovered menu AFTER closing others
      BigMenu.currentHoveredMenu = this;
      
      // Then open this panel
      if (this.panel) {
        this.panel.style.display = "block";
      }
    });

    // Handle mouseleave on the big-menu element
    this.addEventListener("mouseleave", (event) => {
      // Check if we're moving to the panel
      const relatedTarget = event.relatedTarget;
      if (relatedTarget && (this.contains(relatedTarget) || this.panel?.contains(relatedTarget))) {
        return; // Still within this menu area
      }
      
      // We're leaving this menu area
      BigMenu.currentHoveredMenu = null;
      
      // Hide this panel if it doesn't have an active child
      if (this.panel && this.dataset.hasActiveChild !== "true") {
        this.panel.style.display = "none";
      }
      
      // Restore any panels that have active children
      BigMenu.restoreActivePanels();
    });

    // Also handle mouseenter on the panel itself
    if (this.panel) {
      this.panel.addEventListener("mouseenter", () => {
        // Close all other panels first
        BigMenu.closeAllPanels(this);
        // Then set this as current
        BigMenu.currentHoveredMenu = this;
        if (this.panel) {
          this.panel.style.display = "block";
        }
      });

      this.panel.addEventListener("mouseleave", (event) => {
        const relatedTarget = event.relatedTarget;
        // Check if we're moving back to the menu item
        if (relatedTarget && this.contains(relatedTarget)) {
          return; // Moving back to menu item
        }
        
        // We're leaving the panel area
        BigMenu.currentHoveredMenu = null;
        
        // Hide this panel if it doesn't have an active child
        if (this.panel && this.dataset.hasActiveChild !== "true") {
          this.panel.style.display = "none";
        }
        
        // Restore any panels that have active children
        BigMenu.restoreActivePanels();
      });
    }
  }
}

// Register the custom element
customElements.define("big-menu", BigMenu);
